import { z } from 'zod';

export type AIInsights = {
  summary: string[];
  dimensionName: string | null;
  metricsType: MetricsType;
};

export const metricsTypeEnum = z.enum([
  'contribution-metrics',
  'summary',
  'top-bottom-performers',
  'key-metrics',
]);

export type MetricsType = z.infer<typeof metricsTypeEnum>;
